import FormTaskService from 'services/task/subServices/formTask/FormTaskService';

export default {
	'services.formTaskService': {
		class: FormTaskService,
		deps: [{ $ref: 'services.taskStateService' }, { $ref: 'services.formBlockService' }],
	},
};
